module.exports = __webpack_public_path__ + "img/professor.e89ebda0.png";